import 'intersection-observer';

export function boot() {
  // const navContainer = document.querySelector(".nav");
  const navButton = document.querySelector('.nav-title');
  const navContainer = document.querySelector('.menu-container');
  // const closeButton = document.querySelector('.LATClose01');
  const icon = document.querySelector('.icon');

  // openButton.addEventListener("click", openNav);
  // closeButton.addEventListener("click", closeNav);

  let open = false;

  if (!open) {
    navButton.addEventListener('click', openNav);
  }

  //open the nav on the click
  function openNav() {
    icon.innerHTML = "<i class='LATClose01'></i>";
    navContainer.classList.add('active');
    open = true;
    navButton.removeEventListener('click', openNav);
    navButton.addEventListener('click', closeNav);
    // navContainer.style.width = "100%";
  }

  function closeNav() {
    icon.innerHTML = "<i class='LATMenu'></i>";
    navContainer.classList.remove('active');
    open = false;
    navButton.removeEventListener('click', closeNav);
    navButton.addEventListener('click', openNav);
    // navContainer.style.width = "0%";
  }
}
